export default function Section({ links, contact }) {
    const id = links.filter((x) => x.name.toLowerCase().includes("team"))[0].name.replaceAll(" ", "_");
    return (
        <section className="team-section" id={id}>
            <h1> Our Team </h1>
            <div className="team-flex-container">
                {contact ? contact.map((x, i) => {
                    return (
                        <div className="person-card" key={i}>
                            <img src={x.img_src} alt={x.name} className="headshot" />
                            <div>
                                <span> {x.name}</span>
                                <span className="title">{x.title} </span>
                                <span>{x.phone ? `Direct Phone: ${x.phone}` : null}  or ext. {x.ext}</span>
                            </div>
                        </div>
                    )
                }) : null}
            </div>
        </section>
    )
}

